module.exports = __webpack_public_path__ + "img/aParty_111223_H.4ce8e0be.jpg";